/* MAG Signature Sound — Track Insight reviewer */
(function () {
  'use strict';

  var PROJECT_REF = 'jbllyryqhalyltkkkljn';
  var SUPABASE_URL =
    'https://' + PROJECT_REF + '.supabase.co';

  var FUNCTIONS_BASE =
    SUPABASE_URL + '/functions/v1';

  var PUBLISHABLE_KEY =
    'sb_publishable_5RYKqGrMbtlyHTfX5D5IHQ_BDLSoNMz';

  var REVIEWER_EMAIL =
    'support@magsignaturesound.com';

  var STORAGE_KEY =
    'mag_track_insight_reviewer_auth';

  var REFRESH_SKEW_MS = 60000;

  /* -----------------------------------------
     AUTH
  ----------------------------------------- */

  function loadSession() {
    try {
      return JSON.parse(
        sessionStorage.getItem(
          STORAGE_KEY
        ) || 'null'
      );
    } catch (_) {
      return null;
    }
  }

  function saveSession(data) {
    var session = {
      access_token:
        data.access_token,

      refresh_token:
        data.refresh_token || null,

      expires_at:
        Date.now() +
        (
          Number(
            data.expires_in || 3600
          ) * 1000
        ),

      user:
        data.user || null,

      recovery:
        data.recovery === true
    };

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(session)
    );

    return session;
  }

  function clearSession() {
    sessionStorage.removeItem(
      STORAGE_KEY
    );
  }

  async function parseJson(res) {
    var body = {};

    try {
      body = await res.json();
    } catch (_) {}

    if (!res.ok) {
      throw new Error(
        body.error_description ||
        body.msg ||
        body.error ||
        (
          'Request failed (' +
          res.status +
          ')'
        )
      );
    }

    return body;
  }

  function recoveryParams() {
    var query =
      new URLSearchParams(
        window.location.search
      );

    var hash =
      new URLSearchParams(
        window.location.hash
          ? window.location.hash.substring(1)
          : ''
      );

    var source =
      query.get('access_token')
        ? query
        : hash;

    if (
      !source.get('access_token')
    ) {
      return null;
    }

    var type =
      source.get('type');

    if (
      type &&
      type !== 'recovery'
    ) {
      return null;
    }

    return source;
  }

  function readRecoverySession() {
    var params =
      recoveryParams();

    if (!params) {
      return null;
    }

    var session =
      saveSession({
        access_token:
          params.get(
            'access_token'
          ),

        refresh_token:
          params.get(
            'refresh_token'
          ),

        expires_in:
          Number(
            params.get(
              'expires_in'
            ) || 3600
          ),

        recovery: true
      });

    var cleanUrl =
      new URL(
        window.location.href
      );

    [
      'access_token',
      'refresh_token',
      'expires_in',
      'expires_at',
      'token_type',
      'type',
      'provider_token',
      'provider_refresh_token'
    ].forEach(
      function (key) {
        cleanUrl
          .searchParams
          .delete(key);
      }
    );

    cleanUrl.hash = '';

    history.replaceState(
      {},
      document.title,
      cleanUrl.pathname +
      cleanUrl.search
    );

    return session;
  }

  async function signIn(
    email,
    password
  ) {
    var res =
      await fetch(
        SUPABASE_URL +
        '/auth/v1/token?grant_type=password',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'apikey':
              PUBLISHABLE_KEY
          },

          body:
            JSON.stringify({
              email: email,
              password: password
            })
        }
      );

    return saveSession(
      await parseJson(res)
    );
  }

  async function updatePassword(
    password
  ) {
    var session =
      loadSession();

    if (
      !session ||
      !session.access_token
    ) {
      throw new Error(
        'Password recovery session is missing or expired.'
      );
    }

    var res =
      await fetch(
        SUPABASE_URL +
        '/auth/v1/user',
        {
          method: 'PUT',

          headers: {
            'Content-Type':
              'application/json',

            'apikey':
              PUBLISHABLE_KEY,

            'Authorization':
              'Bearer ' +
              session.access_token
          },

          body:
            JSON.stringify({
              password: password
            })
        }
      );

    await parseJson(res);

    session.recovery =
      false;

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(session)
    );

    return true;
  }

  async function refreshSession(
    session
  ) {
    if (
      !session ||
      !session.refresh_token
    ) {
      clearSession();

      throw new Error(
        'Reviewer session expired. Please sign in again.'
      );
    }

    var res =
      await fetch(
        SUPABASE_URL +
        '/auth/v1/token?grant_type=refresh_token',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'apikey':
              PUBLISHABLE_KEY
          },

          body:
            JSON.stringify({
              refresh_token:
                session.refresh_token
            })
        }
      );

    var data =
      await parseJson(res);

    data.recovery =
      session.recovery === true;

    return saveSession(
      data
    );
  }

  async function getSession() {
    var session =
      loadSession();

    if (
      !session ||
      !session.access_token
    ) {
      return null;
    }

    if (
      !session.expires_at ||
      session.expires_at <=
        Date.now() +
        REFRESH_SKEW_MS
    ) {
      session =
        await refreshSession(
          session
        );
    }

    return session;
  }

  async function requireSession() {
    var session =
      await getSession();

    if (!session) {
      throw new Error(
        'Reviewer sign-in required.'
      );
    }

    return session;
  }

  async function reviewerApi(
    action,
    params
  ) {
    var session =
      await requireSession();

    async function request(
      currentSession
    ) {
      return fetch(
        FUNCTIONS_BASE +
        '/reviewer-api',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Authorization':
              'Bearer ' +
              currentSession
                .access_token
          },

          body:
            JSON.stringify(
              Object.assign(
                {
                  action: action
                },
                params || {}
              )
            )
        }
      );
    }

    var res =
      await request(session);

    if (
      res.status === 401 &&
      session.refresh_token
    ) {
      session =
        await refreshSession(
          session
        );

      res =
        await request(
          session
        );
    }

    return parseJson(res);
  }

  /* -----------------------------------------
     UI HELPERS
  ----------------------------------------- */

  function esc(value) {
    return String(
      value == null
        ? ''
        : value
    )
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatDate(value) {
    if (!value) {
      return '—';
    }

    var date =
      new Date(value);

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '—';
    }

    return new Intl
      .DateTimeFormat(
        'en-GB',
        {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }
      )
      .format(date);
  }

  function setCount(
    root,
    selector,
    value
  ) {
    var el =
      root.querySelector(
        selector
      );

    if (el) {
      el.textContent =
        value;
    }
  }

  function clearCounts(root) {
    setCount(
      root,
      '[data-ti-count-new]',
      '—'
    );

    setCount(
      root,
      '[data-ti-count-submitted]',
      '—'
    );

    setCount(
      root,
      '[data-ti-count-review]',
      '—'
    );

    setCount(
      root,
      '[data-ti-count-complete]',
      '—'
    );
  }

  function workspaceBase(root) {
    var existing =
      root.querySelector(
        '[data-ti-open-review]'
      );

    if (existing) {
      var href =
        existing.getAttribute(
          'href'
        );

      if (
        href &&
        href !== '#'
      ) {
        return href
          .split('?')[0];
      }
    }

    return (
      '/pages/' +
      'track-insight-workspace'
    );
  }

  /* -----------------------------------------
     SIGN IN
  ----------------------------------------- */

  function renderLogin(
    root,
    list
  ) {
    clearCounts(root);

    list.innerHTML = `
      <div style="
        padding:42px 0;
        max-width:620px;
      ">

        <p style="
          margin:0 0 10px;
          color:#D67E4A;
          font-size:9px;
          font-weight:800;
          letter-spacing:.14em;
          text-transform:uppercase;
        ">
          Authorised Reviewers Only
        </p>

        <h2 style="
          margin:0 0 14px;
          color:#022B2D;
          font-size:30px;
          line-height:1;
          font-weight:900;
          letter-spacing:-.045em;
          text-transform:uppercase;
        ">
          Sign in to the review queue.
        </h2>

        <p style="
          margin:0 0 28px;
          color:#607273;
          font-size:13px;
          line-height:1.6;
        ">
          Use the shared MAG Track Insight reviewer account.
        </p>

        <form
          data-ti-reviewer-login
          style="
            display:grid;
            gap:18px;
          "
        >

          <div>

            <label style="
              display:block;
              margin-bottom:7px;
              color:#607273;
              font-size:8px;
              font-weight:800;
              letter-spacing:.12em;
              text-transform:uppercase;
            ">
              Email
            </label>

            <input
              type="email"
              value="${esc(REVIEWER_EMAIL)}"
              readonly
              style="
                width:100%;
                padding:12px 0;
                border:0;
                border-bottom:1px solid #D7D8D1;
                background:transparent;
                color:#022B2D;
                font:inherit;
                font-size:14px;
                font-weight:700;
                outline:none;
              "
            >

          </div>

          <div>

            <label style="
              display:block;
              margin-bottom:7px;
              color:#607273;
              font-size:8px;
              font-weight:800;
              letter-spacing:.12em;
              text-transform:uppercase;
            ">
              Password
            </label>

            <input
              type="password"
              required
              autocomplete="current-password"
              data-ti-reviewer-password
              style="
                width:100%;
                padding:12px 0;
                border:0;
                border-bottom:1px solid #D7D8D1;
                background:transparent;
                color:#022B2D;
                font:inherit;
                font-size:14px;
                font-weight:700;
                outline:none;
              "
            >

          </div>

          <button
            type="submit"
            class="ti-reviewer__action"
            style="
              justify-self:start;
              min-width:150px;
            "
            data-ti-reviewer-login-button
          >
            Sign In
          </button>

          <p
            data-ti-reviewer-login-status
            style="
              margin:0;
              color:#D67E4A;
              font-size:10px;
              font-weight:700;
            "
          ></p>

        </form>
      </div>
    `;
  }

  /* -----------------------------------------
     PASSWORD RECOVERY
  ----------------------------------------- */

  function renderRecovery(
    root,
    list
  ) {
    clearCounts(root);

    list.innerHTML = `
      <div style="
        padding:42px 0;
        max-width:620px;
      ">

        <p style="
          margin:0 0 10px;
          color:#D67E4A;
          font-size:9px;
          font-weight:800;
          letter-spacing:.14em;
          text-transform:uppercase;
        ">
          Reviewer Account
        </p>

        <h2 style="
          margin:0 0 14px;
          color:#022B2D;
          font-size:30px;
          line-height:1;
          font-weight:900;
          letter-spacing:-.045em;
          text-transform:uppercase;
        ">
          Choose a new password.
        </h2>

        <p style="
          margin:0 0 28px;
          color:#607273;
          font-size:13px;
          line-height:1.6;
        ">
          Set the password you will use to access the Track Insight review workspace.
        </p>

        <form
          data-ti-reviewer-recovery
          style="
            display:grid;
            gap:18px;
          "
        >

          <div>

            <label style="
              display:block;
              margin-bottom:7px;
              color:#607273;
              font-size:8px;
              font-weight:800;
              letter-spacing:.12em;
              text-transform:uppercase;
            ">
              New password
            </label>

            <input
              type="password"
              required
              minlength="8"
              autocomplete="new-password"
              data-ti-reviewer-new-password
              style="
                width:100%;
                padding:12px 0;
                border:0;
                border-bottom:1px solid #D7D8D1;
                background:transparent;
                color:#022B2D;
                font:inherit;
                font-size:14px;
                font-weight:700;
                outline:none;
              "
            >

          </div>

          <div>

            <label style="
              display:block;
              margin-bottom:7px;
              color:#607273;
              font-size:8px;
              font-weight:800;
              letter-spacing:.12em;
              text-transform:uppercase;
            ">
              Confirm password
            </label>

            <input
              type="password"
              required
              minlength="8"
              autocomplete="new-password"
              data-ti-reviewer-confirm-password
              style="
                width:100%;
                padding:12px 0;
                border:0;
                border-bottom:1px solid #D7D8D1;
                background:transparent;
                color:#022B2D;
                font:inherit;
                font-size:14px;
                font-weight:700;
                outline:none;
              "
            >

          </div>

          <button
            type="submit"
            class="ti-reviewer__action"
            style="
              justify-self:start;
              min-width:170px;
            "
            data-ti-reviewer-recovery-button
          >
            Set Password
          </button>

          <p
            data-ti-reviewer-recovery-status
            style="
              margin:0;
              color:#D67E4A;
              font-size:10px;
              font-weight:700;
            "
          ></p>

        </form>
      </div>
    `;
  }

  /* -----------------------------------------
     REVIEW QUEUE
  ----------------------------------------- */

  function statusDisplay(
    submission
  ) {
    if (
      submission.status ===
      'In Review'
    ) {
      return {
        label:
          'In Review',

        key:
          'review',

        action:
          'Continue Review'
      };
    }

    return {
      label:
        'New',

      key:
        'new',

      action:
        'Open Review'
    };
  }

  function renderQueue(
    root,
    list,
    submissions
  ) {
    var active =
      submissions.filter(
        function (item) {
          return (
            item.status ===
              'Submitted' ||
            item.status ===
              'In Review'
          );
        }
      );

    var submitted =
      submissions.filter(
        function (item) {
          return (
            item.status ===
            'Submitted'
          );
        }
      );

    var inReview =
      submissions.filter(
        function (item) {
          return (
            item.status ===
            'In Review'
          );
        }
      );

    var complete =
      submissions.filter(
        function (item) {
          return (
            item.status ===
            'Complete'
          );
        }
      );

    setCount(
      root,
      '[data-ti-count-new]',
      submitted.length
    );

    setCount(
      root,
      '[data-ti-count-submitted]',
      submitted.length
    );

    setCount(
      root,
      '[data-ti-count-review]',
      inReview.length
    );

    setCount(
      root,
      '[data-ti-count-complete]',
      complete.length
    );

    if (!active.length) {
      list.innerHTML = `
        <div style="
          padding:42px 0;
          color:#607273;
          font-size:13px;
        ">
          No active Track Insight submissions.
        </div>
      `;

      return;
    }

    var base =
      workspaceBase(root);

    list.innerHTML =
      active.map(
        function (
          submission,
          index
        ) {
          var display =
            statusDisplay(
              submission
            );

          var number =
            String(index + 1)
              .padStart(2, '0');

          var href =
            base +
            '?submission=' +
            encodeURIComponent(
              submission.id
            );

          return `
            <article
              class="ti-reviewer__item"
              data-ti-reviewer-row
              data-ti-submission-id="${esc(submission.id)}"
              data-ti-status="${esc(display.key)}"
            >

              <span
                class="ti-reviewer__num"
              >
                ${number}
              </span>

              <div>

                <p
                  class="ti-reviewer__artist"
                >
                  ${esc(
                    submission.artist_name ||
                    'Untitled Artist'
                  )}
                </p>

                <p
                  class="ti-reviewer__customer"
                >
                  ${esc(
                    submission.customer_name ||
                    submission.customer_email ||
                    'Customer'
                  )}
                </p>

              </div>

              <p
                class="ti-reviewer__track"
              >
                ${esc(
                  submission.track_title ||
                  'Untitled Track'
                )}
              </p>

              <span
                class="ti-reviewer__date"
              >
                ${esc(
                  formatDate(
                    submission.submitted_at
                  )
                )}
              </span>

              <span
                class="
                  ti-reviewer__status
                  ti-reviewer__status--${esc(display.key)}
                "
              >
                ${esc(
                  display.label
                )}
              </span>

              <a
                class="ti-reviewer__action"
                href="${esc(href)}"
                data-ti-open-review
              >
                ${esc(
                  display.action
                )}
              </a>

            </article>
          `;
        }
      )
      .join('');
  }

  async function loadQueue(root) {
    var list =
      root.querySelector(
        '[data-ti-reviewer-list]'
      );

    if (!list) {
      return;
    }

    var session =
      await getSession();

    if (!session) {
      renderLogin(
        root,
        list
      );

      return;
    }

    if (
      session.recovery === true
    ) {
      renderRecovery(
        root,
        list
      );

      return;
    }

    list.innerHTML = `
      <div style="
        padding:36px 0;
        color:#607273;
        font-size:11px;
        text-transform:uppercase;
        letter-spacing:.12em;
        font-weight:800;
      ">
        Loading live review queue…
      </div>
    `;

    var response =
      await reviewerApi(
        'list_submissions'
      );

    renderQueue(
      root,
      list,
      response.submissions || []
    );
  }

  /* -----------------------------------------
     FORMS
  ----------------------------------------- */

  function bindForms(root) {
    root.addEventListener(
      'submit',
      async function (event) {

        var recoveryForm =
          event.target.closest(
            '[data-ti-reviewer-recovery]'
          );

        if (recoveryForm) {
          event.preventDefault();

          var newPassword =
            recoveryForm.querySelector(
              '[data-ti-reviewer-new-password]'
            );

          var confirmPassword =
            recoveryForm.querySelector(
              '[data-ti-reviewer-confirm-password]'
            );

          var recoveryButton =
            recoveryForm.querySelector(
              '[data-ti-reviewer-recovery-button]'
            );

          var recoveryStatus =
            recoveryForm.querySelector(
              '[data-ti-reviewer-recovery-status]'
            );

          if (
            !newPassword ||
            !confirmPassword
          ) {
            return;
          }

          if (
            newPassword.value.length <
            8
          ) {
            recoveryStatus.textContent =
              'Please use at least 8 characters.';

            return;
          }

          if (
            newPassword.value !==
            confirmPassword.value
          ) {
            recoveryStatus.textContent =
              'The passwords do not match.';

            return;
          }

          recoveryButton.disabled =
            true;

          recoveryButton.textContent =
            'Saving…';

          recoveryStatus.textContent =
            '';

          try {
            await updatePassword(
              newPassword.value
            );

            recoveryStatus.textContent =
              'Password updated. Loading review queue…';

            await loadQueue(root);

          } catch (error) {
            console.error(
              '[Track Insight reviewer recovery]',
              error
            );

            recoveryStatus.textContent =
              error &&
              error.message
                ? error.message
                : String(error);

            recoveryButton.disabled =
              false;

            recoveryButton.textContent =
              'Set Password';
          }

          return;
        }

        var loginForm =
          event.target.closest(
            '[data-ti-reviewer-login]'
          );

        if (!loginForm) {
          return;
        }

        event.preventDefault();

        var password =
          loginForm.querySelector(
            '[data-ti-reviewer-password]'
          );

        var button =
          loginForm.querySelector(
            '[data-ti-reviewer-login-button]'
          );

        var status =
          loginForm.querySelector(
            '[data-ti-reviewer-login-status]'
          );

        if (
          !password ||
          !password.value
        ) {
          return;
        }

        if (button) {
          button.disabled =
            true;

          button.textContent =
            'Signing In…';
        }

        if (status) {
          status.textContent =
            '';
        }

        try {
          await signIn(
            REVIEWER_EMAIL,
            password.value
          );

          await loadQueue(
            root
          );

        } catch (error) {
          console.error(
            '[Track Insight reviewer login]',
            error
          );

          if (status) {
            status.textContent =
              error &&
              error.message
                ? error.message
                : String(error);
          }

          if (button) {
            button.disabled =
              false;

            button.textContent =
              'Sign In';
          }
        }
      }
    );
  }

  /* -----------------------------------------
     INIT
  ----------------------------------------- */

  function init() {
    if (
      window.Shopify &&
      window.Shopify.designMode
    ) {
      return;
    }

    var root =
      document.querySelector(
        '[data-ti-reviewer-dashboard]'
      );

    if (
      !root ||
      root.dataset
        .tiReviewerLiveReady ===
        'true'
    ) {
      return;
    }

    root.dataset
      .tiReviewerLiveReady =
      'true';

    readRecoverySession();

    bindForms(root);

    loadQueue(root)
      .catch(
        function (error) {
          console.error(
            '[Track Insight reviewer queue]',
            error
          );

          var list =
            root.querySelector(
              '[data-ti-reviewer-list]'
            );

          if (list) {
            list.innerHTML = `
              <div style="
                padding:36px 0;
                color:#D67E4A;
                font-size:11px;
                font-weight:700;
              ">
                ${esc(
                  error &&
                  error.message
                    ? error.message
                    : String(error)
                )}
              </div>
            `;
          }
        }
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();